import { translateMonthName } from 'mmfintech-commons'
import './ActivityDateLine.scss'

interface Props {
  datum: string
}

function ActivityDateLine({ datum }: Props) {
  const dt = new Date(datum)
  const day = dt.getDate()
  const year = dt.getFullYear()
  const month = translateMonthName(dt.getMonth())

  return (
    !isNaN(dt.getDate()) && (
      <div className='activity-date-section date-section'>
        <span className='grid-line left' />
        <span className='date-wrap'>
          <span className='day'>{day}</span>
          <span className='year'>
            {month}, {year}
          </span>
        </span>
        <span className='grid-line right' />
      </div>
    )
  )
}

export default ActivityDateLine
